<template>
  <div>
    <v-textarea v-if="item.definition.isLong"
                :label="label"
                color="valid"
                required
                :aria-required="item.definition.required"
                v-model="localItem.answer.answer"
                :error-messages="fieldErrors"
                @blur="onBlur"
    />
    <v-text-field v-else
                  :label="label"
                  color="valid"
                  required
                  :aria-required="item.definition.required"
                  v-model="localItem.answer.answer"
                  :error-messages="fieldErrors"
                  @blur="onBlur"
    />
  </div>
</template>

<script>
import itemMixin from '@/components/appUser/questionnaires/pageItems/itemMixin'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QuestionOpenItem',
  mixins: [itemMixin],
  computed: {
    ...mapGetters('User', [
      'user'
    ]),
    ...mapGetters('UserQuestionnaire', [
      'changePage',
      'questionnaire'
    ]),
    label () {
      return this.item.definition.question + (
        this.item.definition.required ? ' *' : ''
      )
    },
    fieldErrors () {
      const errors = []
      if (!this.$v.localItem.answer.answer.$dirty) return errors
      if (this.localItem.definition.required && !this.$v.localItem.answer.answer.required) {
        errors.push('Cette question est obligatoire')
      }
      return errors
    }
  },
  watch: {
    changePage () {
      if (this.changePage && this.localItem.definition.required) {
        this.$v.$touch()
      }
    }
  },
  validations: {
    localItem: {
      answer: {
        answer: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions('UserQuestionnaire', [
      'sendAnswer'
    ]),
    onBlur () {
      if (
        this.localItem.answer.answer !== '' &&
        this.localItem.answer.answer !== null &&
        (this.questionnaire.isPublished || this.questionnaire.user === this.user.id)
      ) {
        this.sendAnswer({
          questionId: parseInt(this.localItem.value),
          answer: this.localItem.answer
        })
      }
    }
  }
}
</script>
